import { BYO_LIVE_SCORE_UPDATE } from '../constants';
const initialState = {
    homeTeamName: '',
    awayTeamName: '',
    clock: null,
    score: null,
};
const liveScoreReducer = (state = initialState, action = { type: '', payload: '' }) => {
    if (!action) {
        return state;
    }
    if (action.type === BYO_LIVE_SCORE_UPDATE) {
        const { clock = null, score = null, homeTeam = null, awayTeam = null } = action.payload.data;
        const homeTeamName = homeTeam ? homeTeam.name : '';
        const awayTeamName = awayTeam ? awayTeam.name : '';
        return { homeTeamName, awayTeamName, clock, score };
    }
    return state;
};
export default liveScoreReducer;
